import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import loadingGif from '../../assets/loading.gif';
import { fetchUser, updateUser } from '../../../api/api_users';

function ProfileSettings() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [user_name, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [timeZone, setTimeZone] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('userToken');
    if (token) {
      fetchUser(token)
        .then(response => {
          setUser(response.data);
          setUserName(response.data.user_name);
          setEmail(response.data.email);
          setTimeZone(response.data.timezone || '');
          setLoading(false);
        })
        .catch(error => {
          console.error(translations.fetchDataError, error);
          navigate('/login');
        });
    } else {
      navigate('/login');
    }
  }, [navigate, translations.fetchDataError]);

  const handleSave = () => {
    const token = localStorage.getItem('userToken');
    const updatedUser = { user_name, email, timezone: timeZone };
    updateUser(token, updatedUser)
      .then(() => {
        alert(translations.profileUpdateSuccess);
        navigate('/home');
      })
      .catch(error => {
        console.error('Error updating user:', error);
      });
  };

  const handleHome = () => {
    navigate('/home');
  };

  return (
    <div className="general-page">
      <div className="sm-container">
        <div className="header">
          <button onClick={handleHome} className="back-button">&#8592;</button>
          <h1>{translations.settings}</h1>
        </div>
        {loading ? (
          <div className='pot-loading'> <img src={loadingGif} alt={translations.loading} /> </div>
        ) : (
          <div className="form-container">
            <div className="input-group full-width">
              <label htmlFor="user_name">{translations.username}:</label>
              <input id="user_name" type="text" className="general-input" value={user_name} onChange={(e) => setUserName(e.target.value)} />
            </div>
            <div className="input-group full-width">
              <label htmlFor="email">{translations.email}:</label>
              <input id="email" type="email" className="general-input" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="input-group full-width">
              <label htmlFor="timeZone">{translations.timezone}:</label>
              <select id="timeZone" className="general-input" value={timeZone} onChange={(e) => setTimeZone(Number(e.target.value))}>
                <option value="0">Los Angeles (UTC -8)</option>
                <option value="1">Denver (UTC -7)</option>
                <option value="2">Chicago (UTC -6)</option>
                <option value="3">New York (UTC -5)</option>
                <option value="4">Toronto (UTC -5)</option>
                <option value="5">Sao Paulo (UTC -3)</option>
                <option value="6">London (UTC +0)</option>
                <option value="7">Madrid (UTC +1)</option>
                <option value="8">Paris (UTC +1)</option>
                <option value="9">Rome (UTC +1)</option>
                <option value="10">Berlin (UTC +1)</option>
                <option value="11">Johannesburg (UTC +2)</option>
                <option value="12">Istanbul (UTC +3)</option>
                <option value="13">Moscow (UTC +3)</option>
                <option value="14">Dubai (UTC +4)</option>
                <option value="15">Shanghai (UTC +8)</option>
                <option value="16">Hong Kong (UTC +8)</option>
                <option value="17">Singapore (UTC +8)</option>
                <option value="18">Tokyo (UTC +9)</option>
                <option value="19">Sydney (UTC +10)</option>
              </select>
            </div>
            <button onClick={handleSave} className="general-button full-width">{translations.save}</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ProfileSettings;
